/**
 * @generated SignedSource<<53af7aa8e8abd0c20800b84189b11253>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomPropertyEditForm_roomProperty$data = {
  readonly etgKey: string | null;
  readonly id: string;
  readonly name: string | null;
  readonly " $fragmentType": "RoomPropertyEditForm_roomProperty";
};
export type RoomPropertyEditForm_roomProperty$key = {
  readonly " $data"?: RoomPropertyEditForm_roomProperty$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomPropertyEditForm_roomProperty">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomPropertyEditForm_roomProperty",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "etgKey",
      "storageKey": null
    }
  ],
  "type": "RoomProperty",
  "abstractKey": null
};

(node as any).hash = "1e8886a3ff70fba6aba4af8a3076da4d";

export default node;
